import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { hideModal } from 'appSrc/redux/actions';
import { XIcon } from 'appSrc/components/UI';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import Form from './Form';


class EditProductModal  extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: false,
        };
    }
    submit = ( updates ) => {
        this.setState( { fetching: true } );
        this.props.onSubmit( updates )
        .then( () => {
            this.setState( { fetching: false } );
            this.props.closeModal();
        } );
    }
    render() {
        const { modalName, modalProps } = this.props;
        let goodToGo = false;
        if ( modalName === 'editProductModal' ) {
            goodToGo = true;
        }
        return (
            <ReactModal
            isOpen={ modalProps.modalIsOpen && goodToGo }
            contentLabel="Edit Video"
            onRequestClose={ this.props.closeModal }
            className='modal-popup'
            overlayClassName='modal-overlay' >
                <div className='modal-title'>
                    <h2>Edit Video</h2>
                </div>
                <div className='close-button' onClick={ this.props.closeModal }>
                    <XIcon size={ 24 } />
                </div>
                <Form onSubmit={ this.submit } initialValues={ this.props.item } />
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </ReactModal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
    };
};
const mapDispatchToProps = ( dispatch ) => {
    return {
        closeModal: () => {
            dispatch( hideModal( 'editProductModal' ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( EditProductModal );
